import { useState } from "react";

export const useBooleanMap = () => {
  const [items, setItems] = useState<{ [id: string]: boolean }>({});

  /** Set item's value, if value not specified will act as toggle */
  const setItem = (id: string, value?: boolean) => {
    if (items[id]) {
      if (value) {
        return;
      }

      setItems((current) => {
        const { [id]: v, ...rest } = current;

        return rest;
      });
    } else if (value === undefined || value === true) {
      setItems((current) => ({ ...current, [id]: true }));
    }
  };

  return { items, setItem };
};
